const FB_APP_ID = '670263085138939';

export function useSeoData() {
  function setSeoData({ title, description, image, ogType = 'website' }) {
    const meta = [
      {
        name: 'description',
        content: description,
      },
      {
        rel: 'preload',
        property: 'image',
        content: image,
      },
      { property: 'og:title', content: title },
      { property: 'og:type', content: ogType },
      {
        property: 'og:description',
        content: description,
      },
      {
        rel: 'preload',
        property: 'og:image',
        content: image,
      },
      { property: 'fb:app_id', content: FB_APP_ID },
      {
        property: 'twitter:card',
        content: 'summary',
      },
      {
        property: 'twitter:title',
        content: title,
      },
      {
        property: 'twitter:description',
        content: description,
      },
      {
        rel: 'preload',
        property: 'twitter:image',
        content: image,
      },
    ];

    useHead({
      title,
      meta,
    });
  }

  return {
    set: setSeoData,
  };
}
